import React from "react";
import { DocumentCategories } from "./DocumentCategories";

export const DocumentCategoriesPage: React.FC = () => <DocumentCategories />;
